import styled from 'styled-components'
import { BsSearch } from 'react-icons/bs'
import { AiOutlineUser } from 'react-icons/ai'
import { HiOutlineShoppingBag } from 'react-icons/hi'

export const SearchGlass = styled(BsSearch)`
  font-size: 18px;
`

export const User = styled(AiOutlineUser)`
  font-size: 20px;
`
export const ShoppingBag = styled(HiOutlineShoppingBag)`
  font-size: 22px;
`